import { render, staticRenderFns } from "./MemberPhotoAndSignature.vue?vue&type=template&id=1ccb001e"
import script from "./MemberPhotoAndSignature.vue?vue&type=script&lang=js"
export * from "./MemberPhotoAndSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports